<template>
    <Modal :mask-closable="true" v-model="ModalShow" @on-cancel="close()" :title="title" :footer-hide="true"
        :scrollable="false" class-name="QHImgopen" :width="openWidth(width)">
        <img :src="url">
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            ModalShow: false,
        };
    },
    props: {
        url: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        width: {
            type: Number,
            default: 1000,
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        openWidth(width) {
            var windowWidth = window.innerWidth;
            if(windowWidth<1100){
                width=windowWidth*0.95;
            };
            return width;
        },

        close() {
            this.$emit('close');
        }
    }
};
</script>
<style>
.QHImgopen {
    z-index: 10000 !important;
}

.QHImgopen img {
    width: 100%;
    display: block;
    margin: 0 auto;
    height: auto !important;
}
</style>